module.exports = __webpack_public_path__ + "media/message.ab3a8d5a.mp3";